import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Dev from "@fae/source/models/dev/Dev.js"

import UnitSprite from "@fae/source/views/components/UnitSprite.jsx"
import UnitTemplateSprite from "@fae/source/views/components/UnitTemplateSprite.jsx"
import UnitHealthBar from "@fae/source/views/components/UnitHealthBar.jsx"
import UnitExperienceBar from "@fae/source/views/components/UnitExperienceBar.jsx"

import DiceCube from "@fae/source/data/games/ember/views/DiceCube.jsx"
import ItemBreakdown from "@fae/source/data/games/ember/views/ItemBreakdown.jsx"

import "@fae/source/views/components/Unit.less"

const MOUSE_BUTTON = 2

export default class Unit {
    render() {
        if((this.props.unit.type == "spot")
        && this.props.unit.properties?.includes("visible") != true
        && Dev.inProtoMode == false) {
            return
        }
        const isRolling = this.props.stage.player?.phase == "rolling" || App.game.chapter.selection.isRerolling == true // || (this.props.stage?.turn?.affiliation == "good" && App.game.chapter.previousStages.length == 0) // this.props.stage.player?.phase == "rolling" ||
        // <div class="Selection" isHovered={this.isHovered} isSelected={this.isSelected}/>
        // <div class="ReadyLabel">Locked!</div>
        return [
            <div class="Unit" style={this.style} key={this.props.unit.key} isInBounds={this.isInBounds} affiliation={this.props.unit.affiliation} phase={isRolling ? "rolling" : "playing"}// phase={this.props.stage.player?.phase}
                isHovered={this.isHovered} isSelected={false && this.isSelected} isRolling={isRolling} isLockedIn={this.props.unit.isLockedIn}>
                <UnitSprite unit={this.props.unit} recolor={this.recolor} index={this.props.index}/>
                <UnitHealthBar stage={this.props.stage} unit={this.props.unit} omegaunit={this.props.omegaunit} maxsegments={20}/>
                {App.game.configuration.neverRenderUnitExperience != true && this.props.unit.affiliation == this.props.stage.player?.affiliation && <UnitExperienceBar stage={this.props.stage} unit={this.props.unit}/>}
                {App.game.configuration.alwaysRenderUnitLevel == true && this.props.unit.level > 0 && <div class="UnitLevel">Lv-{this.props.unit.level}</div>}
                <div class="PredictiveDamage">{this.predictiveDamage}</div>
                <div class="ReadyingLabel" isVisible={App.game.chapter.selection.isRerolling}>Reroll?</div>
                <Gab unit={this.props.unit}/>
                {this.props.unit.armor > 0 ? (
                    <div class="ArmorCount">
                        <div class="Text">
                            {this.props.unit.armor / 10} ■
                        </div>
                    </div>
                ) : null}
                {App.game.configuration.isRenderingEquippedItemOnUnit == true && <div class="DiceSection">
                    <DiceCube stage={this.props.stage} unit={this.props.unit} item={this.props.unit.equippedItem}
                        animation={"roll"} key={this.props.unit.rollcount}/>
                </div>}
                <div class="ClickableArea" onMouseDown={this.onMouseDown()} onMouseUp={this.onMouseUp()} onMouseOut={this.onMouseOut()} onMouseOver={this.onMouseOver()}/>
            </div>,
            App.game.configuration.isRenderingEquippedItemOnUnit == true && <div class="UnitItem" isRightClicked={this.isRightClicked}
                 style={{"left": this.position.x + 0.5 + "em", "top": this.position.y + 1.1 + "em"}}>
                <ItemBreakdown item={this.props.unit.equippedItem} unit={this.props.unit} stage={this.props.stage}/>
            </div>
            // <div class="DiceBreakdown"}
            //     isRightClicked={this.isRightClicked}>
            //     <div class="Content">
            //         <div class="Title">{this.props.unit.equippedItem?.title}</div>
            //         <div class="Description">
            //             {this.props.unit.equippedItem?.description.split(", ").map((description) => [<span>{description}</span>, <br/>])}
            //         </div>
            //     </div>
            // </div>
        ]
        // <div class="UnitElement" element={this.props.unit.element} style={{
        //     "background-color": elements[this.props.unit.element]?.color
        // }}/>
    }
    get predictiveDamage() {
        let predictiveType = "hp"
        let predictiveDamage = 0
        if(App.game.chapter.selection.hoveredAction != undefined) {
            App.game.chapter.selection.hoveredAction.steps.forEach((step) => {
                step.deltastages.forEach((deltastage) => {
                    if(deltastage?.type == "particle"
                    && deltastage?.text?.unitKey == this.props.unit.key
                    && (deltastage.text?.type == "damage" || deltastage.text?.type == "healing" || deltastage.text?.type == "armor")) {
                        const text = Number.parseFloat(deltastage.text.string)
                        if(Number.isNaN(text) == false) {
                            predictiveDamage += text
                        }
                        if(deltastage.text?.type == "armor") {
                            predictiveType = " ■"
                        }
                    }
                    // {
                    //     "key": key,
                    //     "type": "particle",
                    //     "mark": mark,
                    //     "text": {
                    //         "string": text,
                    //         "font": font || "numbers",
                    //     },
                    //     "color": color,
                    //     "position": Geometry.add(position, {"z": 0}),
                    // },
                    if(deltastage?.flourish != undefined
                    && deltastage.flourish.name == "TextFloat"
                    && deltastage.flourish.unitKey == this.props.unit.key) {
                        const number = Number.parseFloat(deltastage.flourish.text)
                        if(Number.isNaN(number) == false) {
                            predictiveDamage += number
                        }
                        if(deltastage.flourish.type == "armor") {
                            predictiveType = " ■"
                        }
                    }
                })
            })
        }
        if(predictiveDamage == 0.5) {
            predictiveDamage = "½"
        }
        if(predictiveDamage == -0.5) {
            predictiveDamage = "-½"
        }
        if(predictiveDamage == 0) {
            return ""
        }
        return predictiveDamage + predictiveType
    }
    get style() {
        return {
            "left": this.position.x + "em",
            "top": this.position.y + "em",
            "z-index": (this.props.unit.truestack) ?? (1000 + (this.position.y * 100) + (this.props.unit?.stack || 0)), // + (this.position.x)
            // "z-index": 50 + (this.props.unit?.stack || 0), // DICE removed for stacking
            "opacity": this.props.unit.opacity, // for death
            "transform": this.props.unit.rotation ? "rotate(" + this.props.unit.rotation + "deg)" : "",
        }
    }
    get position() {
        // if(App.game.chapter.selection.position.x == this.props.unit.position.x
        // && App.game.chapter.selection.position.y == this.props.unit.position.y) {
        //     return this.props.unit.position
        // }
        // if(App.game.chapter.selection?.selectedUnitKey == this.props.unit.key
        // && App.game.chapter.selection?.hoveredAction?.omegastage != undefined) {
        //     return App.game.chapter.selection.hoveredAction.omegastage.units[this.props.unit.key].position
        // }
        return this.props.unit.position
    }
    get recolor() {
        if(Dev.inProtoMode == true) return "grayscaled"

        if(App.game.key == "book") {
            if(this.props.unit?.properties?.includes("blacked out until routed")) {
                if(this.props.unit.state == "defensive"
                || this.props.unit.state == "unpredictable-but-defensive") {
                    return "blackedout"
                }
                if(this.props.unit.state == "afraid"
                || this.props.unit.state == "unpredictable"
                || this.props.unit.state == "passive") {
                    return "colored"
                }
                if(this.props.unit.hasAttacked == true) {
                    return "colored"
                }
                return "whitedout"
            }
        }

        if(this.isDone == true
        || this.isInBounds == false) {
            return "grayscaled"
        }
    }
    get isGrayscaled() {
        return this.isDone
    }
    get isDone() {
        // if(this.props.unit.affiliation == "bad") return false // DICE
        if(this.props.unit.energy == undefined) return false
        return this.props.unit.energy["move"] === false
            && this.props.unit.energy["act"] === false
    }
    get isInBounds() {
        if(Dev.inProtoMode == true) return true
        if(this.props.stage.flags["ShowAllTheGuysWithoutTransparency"] == true) return true // pirates
        if(this.props.stage.currentEncounterKey == undefined) return false
        if(this.props.stage.encounters[this.props.stage.currentEncounterKey] == undefined) return false
        return Geometry.isInBounds(this.props.stage.encounters[this.props.stage.currentEncounterKey], {
            "x": Math.round(this.position.x),
            "y": Math.round(this.position.y),
            "z": Math.round(this.position.z)
        })
    }
    get isHovered() {
        // if(Dev.inProtoMode == false) return false
        return this.props.unit.key == App.game.chapter?.selection?.hoveredUnitKey
            || this.props.unit.key == Dev.devSelection.listHoveredUnitKey
    }
    get isSelected() {
        if(Dev.inProtoMode == false) return false
        if(this.props.unit.key == App.game.chapter?.selection?.selectedUnitKey) return true
        if(App.game.chapter?.selection?.multiselectedUnitKeys.includes(this.props.unit.key)) return true
        return false
    }

    onMouseDown() {
        return (event) => {
            if(event.button != MOUSE_BUTTON) return
            event.stopPropagation()
            window.hasRightClicked = true
            this.isRightClicked = true
        }
    }
    onMouseUp() {
        return (event) => {
            if(event.button != MOUSE_BUTTON) return
            event.stopPropagation()
            window.hasRightClicked = true
            this.isRightClicked = false
        }
    }
    onMouseOut() {
        return (event) => {
            event.stopPropagation()
            window.hasRightClicked = true
            this.isRightClicked = false
        }
    }
    onMouseOver() {
        return (event) => {
            if(event.button != MOUSE_BUTTON && event.buttons != MOUSE_BUTTON) return
            event.stopPropagation()
            window.hasRightClicked = true
            this.isRightClicked = true
        }
    }
}

class Gab {
    render() {
        if(this.props.unit?.gab == undefined) return

        const isActive = this.props.unit.key == App.game.chapter?.selection?.selectedUnitKey
            || this.props.unit.key == App.game.chapter?.selection?.hoveredUnitKey

        if(this.props.unit.gab.minimizedTime != undefined
        && Date.now() > this.props.unit.gab.minimizedTime
        && isActive == false) {
            return
        }
        if(this.props.unit.gab.fadedTime != undefined
        && Date.now() > this.props.unit.gab.fadedTime) {
            return
        }
        return (
            <div class="Gab">
                <span class="Text">{this.text}</span>
            </div>
        )
    }
    get text() {
        if(this.props.unit.key == App.game.chapter?.selection?.selectedUnitKey
        || this.props.unit.key == App.game.chapter?.selection?.hoveredUnitKey) {
            return this.props.unit.gab.text
        }
        return this.props.unit.gab.minimizedText || this.props.unit.gab.text
    }
}
